import { SVGProps } from 'react';

const CircleCheckBig = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21.801 10A10 10 0 1 1 17 3.335M9 11l3 3L22 4"
    />
  </svg>
);
export default CircleCheckBig;
